import React, { useEffect, useState } from 'react'
import ModalActionButton from '../../elements/ModalActionButton'
import { createAssessment } from '../../../store/actions/assessmentsActions'
import { ERROR } from '../../../store/types'
import { fetchAcademicSessions } from '../../../store/actions/academicSessionsActions'
import { useDispatch, useSelector } from 'react-redux'
import Loader from '../../elements/Loader'
import SelectField from '../../elements/form/SelectField'
import { fetchTerms } from '../../../store/actions/termsActions'
import TextField from '../../elements/form/TextField'
import RadioGroup from '../../elements/form/RadioGroup'
import DateField from '../../elements/form/DateField'
import moment from 'moment'
import NumberField from '../../elements/form/NumberField';

const CreateAssessment = ({
    close
}) => {
    const [assessmentPayload, setAssessmentPayload] = useState({})
    const [validationErrors, setValidationErrors] = useState({})
    
    const dispatch = useDispatch()
    const sessionsSelector = useSelector((state => state.academicSessions))
    const termsSelector = useSelector((state => state.terms))
    const assessmentsSelector = useSelector((state => state.assessments))
    
    useEffect(() => {
        dispatch(fetchAcademicSessions())
   
        return () => {
            
        }
    }, [dispatch])   

    const validateForm = () => {
        let errors = {}

        if(!assessmentPayload.name || assessmentPayload.name === '') {
            errors.name = true
        }

        if(!assessmentPayload.description || assessmentPayload.description === '') {
            errors.description = true
        }

        if(!assessmentPayload.dateFrom || assessmentPayload.dateFrom === '') {
            errors.dateFrom = true
        }

        if(!assessmentPayload.dateTo || assessmentPayload.dateTo === '') {
            errors.dateTo = true
        }

        if(!assessmentPayload.academicSession || assessmentPayload.academicSession === '') {
            errors.academicSession = true
        }

        if(!assessmentPayload.term || assessmentPayload.term === '') {
            errors.term = true
        }

        console.log(errors)

        setValidationErrors(errors)
        return errors
    }

    const pushAssessment = () => {
        if (Object.values(validateForm()).includes(true)) {
            dispatch({
                type: ERROR,
                error: {response: {data: {
                    message: 'Please check the highlighted fields'
                }}}
            });
            return
        }

        const payload = {
            ...assessmentPayload, 
            dates: {
                from: assessmentPayload.dateFrom,
                to: assessmentPayload.dateTo
            }
        }

        dispatch(createAssessment(payload))
    }

    const assessmentTypes = [
        {
            label: 'Continuous Assessment',
            value: 'continuous-assessment'
        },
        {
            label: "Term Examination",
            value: "term-examination"
        }
    ]

    return (
        <>
        <p className='text-sm text-gray-600 pb-5 mb-5 border-b border-gray-300'>Please provide details of the new assessment below. Once created, staff will be able to add student scores/records against it.</p>
            <div className='mb-4'>
                <TextField
                    inputLabel="Assessment Name" 
                    fieldId="assessment-name" 
                    inputPlaceholder={`The name of the assessment`}
                    inputType="text" 
                    requiredField={true}
                    preloadValue={assessmentPayload.name || ''}
                    hasError={validationErrors && validationErrors.title} 
                    returnFieldValue={(value)=>{setAssessmentPayload({...assessmentPayload, ...{name: value}})}}
                />
            </div>
            <div className='mb-4'>
                <TextField
                    inputLabel="Description" 
                    fieldId="assessment-description" 
                    inputType="text" 
                    inputPlaceholder={`Short description for the assessment`}
                    requiredField={true}
                    preloadValue={assessmentPayload.description || ''}
                    hasError={validationErrors && validationErrors.description} 
                    returnFieldValue={(value)=>{setAssessmentPayload({...assessmentPayload, ...{description: value}})}}
                />
            </div>
            <div className='mb-4'>
                <NumberField
                    inputLabel="Total Marks" 
                    fieldId="assessment-total-marks" 
                    inputType="number" 
                    inputPlaceholder={`Total marks for the assessment`}
                    requiredField={true}
                    preloadValue={assessmentPayload.totalMarks || ''}
                    hasError={validationErrors && validationErrors.totalMarks} 
                    returnFieldValue={(value)=>{setAssessmentPayload({...assessmentPayload, ...{totalMarks: value}})}}
                />
            </div>
            <div className='mb-4'>
                <RadioGroup 
                    items={assessmentTypes} 
                    inline={true}
                    preSelectedIndex={assessmentTypes.findIndex(item => item.value === assessmentPayload.type)}
                    inputLabel={'Assessment Type'}
                    requiredField={true}
                    returnSelected={(value) => {setAssessmentPayload({...assessmentPayload, ...{type: value.value}})}} 
                    hasError={validationErrors && validationErrors.type}  
                    titleField='label'
                />
            </div>
            <div className='w-full'>
                {sessionsSelector?.academicSessions?.academicSessions?.length > 0 ? <SelectField
                    selectOptions={sessionsSelector.academicSessions.academicSessions}
                    inputLabel="Select academic session"
                    titleField="name"
                    displayImage={false}
                    imageField=""
                    requiredField={true}
                    preSelectedIndex={ assessmentPayload.academicSession ? 
                        sessionsSelector.academicSessions.academicSessions.findIndex(item => 
                        item._id === assessmentPayload.academicSession 
                    ) : ''}
                    preSelectedLabel="_id"
                    fieldId="fee-select"
                    hasError={validationErrors && validationErrors.academicSession}
                    disabled={false}
                    // return id of accounts of the selected option
                    returnFieldValue={(value) => {
                        setAssessmentPayload({...assessmentPayload, ...{academicSession: value._id}})
                        dispatch(fetchTerms(`session=${value._id}`), 0, 0)
                    }}
                /> 
                : 
                    <div className='w-full bg-gray-100 p-4  rounded text-xs text-gray-700 flex items-center justify-center'>
                        <p>There are no sessions yet. To be able to choose a session for this record, please navigate to "Administration &gt; Academic sessions" on the left sidebar and create one.</p>
                    </div>
                }
            </div>

            {assessmentPayload.academicSession && assessmentPayload.academicSession !== '' && 
            <>
                <div className='w-full my-4'>
                    {termsSelector.loadingTerms ? 
                    <Loader />
                    :
                    <>
                        {termsSelector?.terms?.terms?.length > 0 ? 
                            <SelectField
                                selectOptions={termsSelector?.terms?.terms}
                                inputLabel="Select term"
                                titleField="name"
                                displayImage={false}
                                imageField=""
                                requiredField={true}
                                preSelectedIndex={ assessmentPayload?.term ? 
                                    termsSelector?.terms?.terms?.findIndex(item => 
                                    item._id === assessmentPayload.term 
                                ) : ''}
                                preSelectedLabel="_id"
                                fieldId="term-select"
                                hasError={validationErrors && validationErrors.term}
                                disabled={false}
                                // return id of accounts of the selected option
                                returnFieldValue={(value) => {
                                    setAssessmentPayload({...assessmentPayload, ...{term: value._id}})
                                }}
                            /> 
                        : 
                            <div className='w-full bg-gray-100 p-4  rounded text-xs text-gray-700 flex items-center justify-center'>
                                <p>There are no terms in this session yet.</p>
                            </div>
                        }
                    </>
                    }
                </div>

            </>
            }

            <div className='w-full flex items-start gap-x-[20px]'>
                <div className='my-2 w-full'>
                    <DateField
                        inputLabel="Start Date" 
                        fieldId="start-date" 
                        requiredField={true}
                        inputType="text" 
                        preloadValue={(moment(assessmentPayload.dateFrom).format('YYYY-MM-DD')) || ''}
                        hasError={validationErrors && validationErrors.dateFrom} 
                        returnFieldValue={(value)=>{
                            // const formattedDate = (moment(value, 'YYYY-MM-DD').format('DD-MM-YYYY'))
                            setAssessmentPayload({...assessmentPayload, ...{dateFrom: new Date(value)}})
                        }}
                    />
                </div>

                <div className='my-2 w-full'>
                    <DateField
                        inputLabel="End Date" 
                        fieldId="end-date" 
                        requiredField={true}
                        inputType="text" 
                        preloadValue={(moment(assessmentPayload.dateTo).format('YYYY-MM-DD')) || ''}
                        hasError={validationErrors && validationErrors.dateTo} 
                        returnFieldValue={(value)=>{
                            // const formattedDate = (moment(value, 'YYYY-MM-DD').format('DD-MM-YYYY'))
                            setAssessmentPayload({...assessmentPayload, ...{dateTo: new Date(value)}})
                        }}
                    />
                </div>
            </div>
            
            

            <div className="mt-8 flex flex-row-reverse gap-x-4">
                <ModalActionButton
                    buttonLabel={'Create Assessment'}
                    buttonAction={()=>{pushAssessment()}}
                    processing={assessmentsSelector?.creatingAssessment}
                />

                <button
                    type="button"
                    className="inline-flex justify-center px-5 py-4 text-xs font-medium bg-transparent border border-transparent rounded-md hover:bg-opacity-50 hover:bg-secondary focus:outline-none"
                    onClick={()=>{close()}}
                >
                    Close
                </button>
                
            </div>
        </>
    )
}

export default CreateAssessment